import CustomerAddressSelect from "components/Customer/CustomerAddressSelect";
import { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { toShippingAddress } from "./splitAddress";

// [field, placeholder, bootstrap col width, required]
const FIELDS = [
  ["addressCompany", "Company / Name", 6, false],
  ["addressContact", "Attention / Contact", 6, false],
  ["addressLine1", "Address line 1", 6, true],
  ["addressLine2", "Address line 2", 6, false],
  ["city", "City", 4, true],
  ["state", "State", 2, true],
  ["zip", "Zip", 3, true],
  ["country", "Country", 3, false],
];

const EMPTY = Object.fromEntries(FIELDS.map(([f]) => [f, ""]));

/**
 * Pick a split's ship-to address: type it (most customers have no saved
 * addresses) or take one of the customer's saved ones. Opens pre-filled
 * with the split's current address so it can be edited.
 */
export default function SplitAddressModal({
  show,
  onHide,
  onSelect,
  initial,
  customerId,
  title,
}) {
  const [form, setForm] = useState(EMPTY);

  useEffect(() => {
    if (show) setForm({ ...EMPTY, country: "US", ...(initial || {}) });
  }, [show, initial]);

  return (
    <Modal show={show} onHide={onHide} size="xl" centered>
      <Modal.Header closeButton>
        <Modal.Title>{title || "Ship-to address"}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <form
          className="border rounded bg-white p-3 mb-3"
          onSubmit={(e) => {
            e.preventDefault();
            onSelect(toShippingAddress(form));
          }}
        >
          <h5 className="mb-2">Type or edit the address</h5>
          <div className="row g-2">
            {FIELDS.map(([field, label, col, required]) => (
              <div className={`col-md-${col}`} key={field}>
                <input
                  className="form-control form-control-sm"
                  placeholder={label + (required ? " *" : "")}
                  aria-label={label}
                  required={required}
                  value={form[field] || ""}
                  onChange={(e) =>
                    setForm((f) => ({ ...f, [field]: e.target.value }))
                  }
                />
              </div>
            ))}
          </div>
          <div className="text-end mt-2">
            <button type="submit" className="btn btn-sm btn-success">
              Use this address
            </button>
          </div>
        </form>

        {customerId && (
          <>
            <h5 className="mb-2">Or pick a saved address</h5>
            {/* WorkOrders.customerId is customers.id, hence isPrimaryId. */}
            <CustomerAddressSelect
              customerId={customerId}
              isPrimaryId={true}
              handleSelectAddress={(a) => onSelect(toShippingAddress(a))}
            />
          </>
        )}
      </Modal.Body>
    </Modal>
  );
}
